import React, { useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../../common/types';

import {
    Grid,
    Button,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    Checkbox,
    InputAdornment,
    FormGroup
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import IndexedDb from '../IndexedDb';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import api from "../../../store/api";
import { format } from "date-fns";
import MedicationAutocomplete from '../../booking/SubPageWidgets/MedicationAutocomplete';
import MedicationDetails from "../../transferDetails/MedicationDetails";
import TimeInput from '../../ui/TimeInput';
interface PcrWidgetProps extends IAppPropsWithRoute {
    careGiversListChanged: any,
    setCareGiversListChanged: any
};
interface MedicationInternal {
    dateAndTimeObject?: Date | null;
    dateAndTime: string | null;
    name: string | null;
    brandId?: string | null;
    monographId?: string | null;
    monographType?: number | null;
    dose?: string;
    unit?: number;
    route?: number;
    errors?: { [index: string]: string };
}

interface SelectItem extends React.Props<any> {
    text: string | undefined;
    value: string | undefined;
    selected: boolean;
}
type medicationDetails = {
    brandId: string;
    monographId: string;
    monographType: number;
};
interface Observation {
    name: string | null;
    BrandId: string | null;
    MonographId: string | null;
    MonographType: string | null;
    dose: string | null;
    time: string | null;
    formatedtime: string | null;
    route: string | null;
    administratedBy?: String | null,
    errorAdministeringMedication?: boolean,
    detailsPatient?: boolean,
    detailsDrug?: boolean,
    detailsTime?: boolean,
    detailsDose?: boolean,
    detailsRoute?: boolean,
    moreDetails: String | null,
}

const SubFormWidget: React.FC<PcrWidgetProps> = ({ careGiversListChanged, setCareGiversListChanged }: any) => {
    const createDefaultEmptyList = (length: number): MedicationInternal[] => {
        let result: MedicationInternal[] = [];
        if (length > 0) {
            let i = 1;
            for (; i <= length; i++) {
                result.push({
                    dateAndTime: null,
                    dateAndTimeObject: null,
                    name: null,
                });
            }
        }
        return result;
    };

    const classes = useStyles();
    const history = useHistory();
    const [Indexdb, setIndexdb] = useState("");
    const [medicationname, setmedicationname] = useState("");
    const [medicationtime, setmedicationtime] = useState(new Date());
    const [medicationdose, setmedicationdose] = useState("");
    const [medicationroute, setmedicationroute] = useState("");
    const [medicationadministered_by, setmedicationadministered_by] = useState("");
    const [medicationRoutes, setMedicationRoutes] = useState<SelectItem[]>([]);
    const [medicationadministered_bys, setMedicationadministered_bys] = useState<SelectItem[]>([]);
    const [medications, setMedications] = useState<MedicationInternal[]>(createDefaultEmptyList(4));

    const [error_administering, seterror_administering] = useState("");
    const [wrong_detailsPatient, setwrong_detailsPatient] = useState("");
    const [wrong_detailsDrug, setwrong_detailsDrug] = useState("");
    const [wrong_detailsTime, setwrong_detailsTime] = useState("");
    const [wrong_detailsDose, setwrong_detailsDose] = useState("");
    const [wrong_detailsRoute, setwrong_detailsRoute] = useState("");
    const [more_detail, setmore_detail] = useState('');
    const [more_detaillength, setmore_detaillength] = useState('');

    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
    const pcrType = watch("pcr_type");
    const [formFields, setFormFields] = useState([
        {
            name: '', time: new Date(), dose: '', route: ''
            , administratedBy: '', errorAdministeringMedication: false,
            detailsPatient: false, detailsDrug: false, detailsTime: false, detailsDose: false, detailsRoute: false, moreDetails: ''
        },
    ])
    let medname: any = null;
    let BrandId: any = null;
    let MonographId: any = null;
    let MonographType: any = null;
    let mims: any = false;
    const [isSnowMedicationModal, setIsSnowMedicationModal] = useState(false);
    const [modalMedicationType, setModalMedicationType] = useState<medicationDetails | null>(null);
    const [modalMedicationName, setModalMedicationName] = useState("");
    const [brandids, setbrandids] = useState<any>();
    const {
        fields: MedicationsFields,
        append: MedicationsAppend,
        remove: MedicationsRemove
    } = useFieldArray({ control, name: "medications" });
    let erroradministeringchange: any = "";
    let detailsPatientchange: any = "";
    let detailsDrugchange: any = "";
    let detailsTimechange: any = "";
    let detailsDosechange: any = "";
    let detailsRoutechange: any = "";
    let routelength: any = "";
    let administedbylength: any = "";
    let administered_by: any = "";
    let route: any = "";
    let dose: any = "";
    let doselength: any = "";
    let varmedicationtime: Date = new Date();
    let moredetails: any = "";
    let moredetailslength: any = "";

    React.useEffect(() => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        getindexdbvalues();
        getMeidcationRoutes();
        handleCareGiversListChange();
    }, [])


    React.useEffect(() => {
        if (careGiversListChanged > 0) {
            handleCareGiversListChange();
        }
    }, [careGiversListChanged])

    React.useEffect(() => {
    }, [medicationadministered_bys])

    const handleCareGiversListChange = async () => {
        let db = localStorage.getItem("PatientDB");
        if (db !== null && db !== "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let careValue = await indexedDb.getAllValue("Caregivers");
            let _cgNames: SelectItem[] = [];
            let _names: string[] = [];
            if (careValue.length != 0) {
                careValue[0].value.column.forEach((item: { name: any; id: any; }) => {
                    if ((item.name != "" && item.name != null)) {
                        let _cgName: SelectItem = { text: item.name, value: item.id, selected: false };
                        _names.push(item.name);
                        _cgNames.push(_cgName);
                    }
                });
                setMedicationadministered_bys(_cgNames);
            }
            let medications = await indexedDb.getAllValue("MedicationAdminstered");
            if (medications.length != 0) {
                medications.forEach(async (item: any) => {
                    if (!_names.includes(item.value.administratedBy)) {
                        var res = await indexedDb.getValue('MedicationAdminstered', item.Key);
                        let mname, mtime, mdose, mroute, mtimeval, brandId, monographId, monographType, brands
                            , madministered_by, merror_administering,
                            mwrong_detailsPatient, mwrong_detailsDrug, mwrong_detailsTime, mwrong_detailsDose, mwrong_detailsRoute
                            , mmore_detail;
                        if (res !== undefined) {
                            mname = res.value.name;
                            mtime = res.value.time;
                            mdose = res.value.dose;
                            mroute = res.value.route;
                            brandId = res.value.BrandId;
                            monographId = res.value.MonographId;
                            monographType = res.value.MonographType;
                            mtimeval = res.value.time != undefined ? format(res.value.time, "HH:mm:ss") : "";
                            brands = res.value.Brands;
                            madministered_by = res.value.administratedBy;
                            merror_administering = res.value.errorAdministeringMedication;
                            mwrong_detailsPatient = res.value.detailsPatient;
                            mwrong_detailsDrug = res.value.detailsDrug;
                            mwrong_detailsTime = res.value.detailsTime;
                            mwrong_detailsDose = res.value.detailsDose;
                            mwrong_detailsRoute = res.value.detailsRoute;
                            mmore_detail = res.value.moreDetails;
                        }
                        await indexedDb.putBulkValue('MedicationAdminstered',
                            [{
                                name: mname,
                                BrandId: brandId,
                                Brands: brands,
                                MonographId: monographId,
                                MonographType: monographType,
                                dose: mdose,
                                time: mtime,
                                formatedtime: mtimeval,
                                route: mroute,
                                administratedBy: "",
                                errorAdministeringMedication: merror_administering,
                                detailsPatient: mwrong_detailsPatient,
                                detailsDrug: mwrong_detailsDrug,
                                detailsTime: mwrong_detailsTime,
                                detailsDose: mwrong_detailsDose,
                                detailsRoute: mwrong_detailsRoute,
                                moreDetails: mmore_detail
                            }], item.Key);
                        getindexdbvalues();
                    }
                });
            }
        }
    }
    const handleFormChangemedicationdose = (event: any, index: any) => {
        // 
        let data = [...formFields];
        setFormFields(data);

        if (event?.target?.value == "") {
            doselength = "0"
        }
        dose = event.target.value;
        setmedicationdose(event.target.value);

        submit(index);
    }
    const handleFormChangemedicationroute = (event: any, index: any) => {
        let data = [...formFields];
        setFormFields(data);
        if (event?.target?.value.length == "") {
            routelength = "0"
        }

        route = event.target.value;
        setmedicationroute(event.target.value);

        submit(index);
    }
    const handleFormChangemedicationadministratedby = (event: any, index: any) => {
        let data = [...formFields];
        setFormFields(data);

        if (event?.target?.value.length == "") {
            administedbylength = "0"
        }
        administered_by = event.target.value;
        setmedicationadministered_by(event.target.value);

        submit(index);
    }
    const handleFormChangeerror_administering = (event: any, index: any, value: { medname: string | null; result: string | null }) => {
        let data = [...formFields];
        setFormFields(data);
        erroradministeringchange = event.target.checked;
        seterror_administering(event.target.checked);

        MedicationsFields.forEach((item) => {
            if (item.name === value.medname) {
                item.errorAdministeringMedication = Boolean(value.result);
            }
        });
        submit(index);
    }
    const handleFormChangewrong_detailsPatient = (event: any, index: any, value: { medname: string | null; result: string | null }) => {
        let data = [...formFields];
        setFormFields(data);
        detailsPatientchange = event.target.checked;
        setwrong_detailsPatient(event.target.checked);

        MedicationsFields.forEach((item) => {
            if (item.name === value.medname) {
                item.detailsPatient = Boolean(value.result);
            }
        });

        submit(index);
    }
    const handleFormChangewrong_detailsDrug = (event: any, index: any, value: { medname: string | null; result: string | null }) => {

        let data = [...formFields];
        setFormFields(data);
        detailsDrugchange = event.target.checked;
        setwrong_detailsDrug(event.target.checked);

        MedicationsFields.forEach((item) => {
            if (item.name === value.medname) {
                item.detailsDrug = Boolean(value.result);
            }
        });
        submit(index);
    }
    const handleFormChangewrong_detailsTime = (event: any, index: any, value: { medname: string | null; result: string | null }) => {
        let data = [...formFields];
        setFormFields(data);
        detailsTimechange = event.target.checked;
        setwrong_detailsTime(event.target.checked);

        MedicationsFields.forEach((item) => {
            if (item.name === value.medname) {
                item.detailsTime = Boolean(value.result);
            }
        });
        submit(index);
    }
    const handleFormChangewrong_detailsDose = (event: any, index: any, value: { medname: string | null; result: string | null }) => {
        let data = [...formFields];
        setFormFields(data);
        detailsDosechange = event.target.checked;
        setwrong_detailsDose(event.target.checked);

        MedicationsFields.forEach((item) => {
            if (item.name === value.medname) {
                item.detailsDose = Boolean(value.result);
            }
        });
        submit(index);
    }

    const handleFormChangewrong_detailsRoute = (event: any, index: any, value: { medname: string | null; result: string | null }) => {
        let data = [...formFields];
        setFormFields(data);
        detailsRoutechange = event.target.checked;
        setwrong_detailsRoute(event.target.checked);

        MedicationsFields.forEach((item) => {
            if (item.name === value.medname) {
                item.detailsRoute = Boolean(value.result);
            }
        });
        submit(index);
    }
    const handleFormChangemedicationmoredetails = (event: any, index: any, value: { medname: string | null; result: string | null }) => {
        let data = [...formFields];
        setFormFields(data);
        setmore_detail(event.target.value);

        if (event?.target?.value.length == 0) {
            setmore_detaillength("0");
            moredetailslength = "0";
        }

        moredetails = event.target.value;

        MedicationsFields.forEach((item) => {
            if (item.name === value.medname) {
                item.moreDetails = event.target.value;
            }
        });

        submit(index);
    }

    const submit = async (index: any): Promise<void> => {
        if (Indexdb != null || Indexdb != "") {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            var res = await indexedDb.getValue('MedicationAdminstered', 'Medication' + index);
            let mname, mtime, mdose, mroute, mtimeval, brandId, monographId, monographType, brands
                , madministered_by, merror_administering,
                mwrong_detailsPatient, mwrong_detailsDrug, mwrong_detailsTime, mwrong_detailsDose, mwrong_detailsRoute
                , mmore_detail;
            if (res !== undefined) {
                mname = res.value.name;
                mtime = res.value.time;
                mdose = res.value.dose;
                mroute = res.value.route;
                brandId = res.value.BrandId;
                monographId = res.value.MonographId;
                monographType = res.value.MonographType;
                mtimeval = res.value.time != undefined ? format(res.value.time, "HH:mm:ss") : "";
                brands = res.value.Brands;
                madministered_by = res.value.administratedBy;
                merror_administering = res.value.errorAdministeringMedication;
                mwrong_detailsPatient = res.value.detailsPatient;
                mwrong_detailsDrug = res.value.detailsDrug;
                mwrong_detailsTime = res.value.detailsTime;
                mwrong_detailsDose = res.value.detailsDose;
                mwrong_detailsRoute = res.value.detailsRoute;
                mmore_detail = res.value.moreDetails;
            }
            await indexedDb.putBulkValue('MedicationAdminstered',
                [{
                    name: medname !== null && medname !== '' ? medname : mname,
                    BrandId: brandId,
                    Brands: brands,
                    MonographId: monographId,
                    MonographType: monographType,
                    dose: dose !== null && (dose !== '' || (doselength === "0" && dose === '')) ? dose : mdose,
                    time: varmedicationtime !== null ? varmedicationtime : mtime,
                    formatedtime: varmedicationtime !== null ? format(varmedicationtime, "HH:mm:ss") : mtimeval,
                    route: route !== null && (route !== '' || (routelength === "0" && route === '')) ? route : mroute,
                    administratedBy: administered_by !== null && (administered_by !== '' || (administedbylength === "0" && administered_by === '')) ? administered_by : madministered_by,
                    errorAdministeringMedication: erroradministeringchange !== null && erroradministeringchange !== '' ? erroradministeringchange : merror_administering,
                    detailsPatient: detailsPatientchange !== null && detailsPatientchange !== '' ? detailsPatientchange : mwrong_detailsPatient,
                    detailsDrug: detailsDrugchange !== null && detailsDrugchange !== '' ? detailsDrugchange : mwrong_detailsDrug,
                    detailsTime: detailsTimechange !== null && detailsTimechange !== '' ? detailsTimechange : mwrong_detailsTime,
                    detailsDose: detailsDosechange !== null && detailsDosechange !== '' ? detailsDosechange : mwrong_detailsDose,
                    detailsRoute: detailsRoutechange !== null && detailsRoutechange !== '' ? detailsRoutechange : mwrong_detailsRoute,
                    moreDetails: moredetails !== null && (moredetails !== '' || (moredetailslength === "0" && moredetails === '')) ? moredetails : mmore_detail
                }], 'Medication' + index);
        }
    }
    const handleindexsave = async (index: any, name: any, brandIds: any, monographIds: any, monographTypes: any): Promise<void> => {
        let values = getValues();

        if (Indexdb != null || Indexdb != "") {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            var res = await indexedDb.getValue('MedicationAdminstered', 'Medication' + index);
            let mtime = new Date()
            let mtimeval = format(new Date(), "HH:mm:ss")
            let mname, mdose, mroute, brandId, monographId, monographType, brands
                , madministered_by, merror_administering,
                mwrong_detailsPatient, mwrong_detailsDrug, mwrong_detailsTime, mwrong_detailsDose, mwrong_detailsRoute
                , mmore_detail;
            if (res !== undefined) {
                mname = res.value.name;
                mtime = res.value.time;
                mdose = res.value.dose;
                mroute = res.value.route;
                brandId = res.value.BrandId;
                monographId = res.value.MonographId;
                monographType = res.value.MonographType;
                mtimeval = res.value.time != undefined ? format(res.value.time, "HH:mm:ss") : "";
                brands = res.value.Brands;
                madministered_by = res.value.administratedBy;
                merror_administering = res.value.errorAdministeringMedication;
                mwrong_detailsPatient = res.value.detailsPatient;
                mwrong_detailsDrug = res.value.detailsDrug;
                mwrong_detailsTime = res.value.detailsTime;
                mwrong_detailsDose = res.value.detailsDose;
                mwrong_detailsRoute = res.value.detailsRoute;
                mmore_detail = res.value.moreDetails;
            }

            await indexedDb.putBulkValue('MedicationAdminstered',
                [{
                    name: mname !== null && mname === name ? mname : name,
                    BrandId: brandId !== null && mname === name ? brandId : brandIds,
                    Brands: brandId !== null && mname === name ? brands : brandIds !== null ? true : false,
                    MonographId: monographId !== null && mname === name ? monographId : monographIds,
                    MonographType: monographType !== null && mname === name ? monographType : monographTypes,
                    dose: mname === name ? mdose : mdose,
                    time: mname === name ? mtime : mtime,
                    formatedtime: mname === name ? mtimeval : mtimeval,
                    route: mname === name ? mroute : mroute,
                    administratedBy: mname === name ? madministered_by : madministered_by,
                    errorAdministeringMedication: mname === name ? merror_administering : merror_administering,
                    detailsPatient: mname === name ? mwrong_detailsPatient : mwrong_detailsPatient,
                    detailsDrug: mname === name ? mwrong_detailsDrug : mwrong_detailsDrug,
                    detailsTime: mname === name ? mwrong_detailsTime : mwrong_detailsTime,
                    detailsDose: mname === name ? mwrong_detailsDose : mwrong_detailsDose,
                    detailsRoute: mname === name ? mwrong_detailsRoute : mwrong_detailsRoute,
                    moreDetails: mname === name ? mmore_detail : mmore_detail
                }], 'Medication' + index);


        }
    }
    const getindexdbvalues = async (): Promise<void> => {
        let db: any = null;

        db = localStorage.getItem("PatientDB");
        if (db != null && db != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('MedicationAdminstered');
            MedicationsRemove();
            for (let i = 0; i < val.length; i++) {
                if (val[i].Key.includes("Medication")) {
                    let res = val[i].value;
                    MedicationsAppend(res);
                    setValue(`medications[${i}].time`, res.time);
                }
            }

        }

    }

    const handleDateChange = (name: any, date: any, index: any) => {
        varmedicationtime = new Date(date);
        setmedicationtime(new Date(date));
        setValue(`medications[${index}].time`, date);

        MedicationsFields.forEach((item) => {
            if (item.name === name) {
                item.time = date;
            }
        })

        submit(index);
    };

    const onChangeMedicationField = (index: number, value: { name: string | null; monographId: string | null; brandId: string | null; monographType: string | null }) => {
        //

        let items = [...medications];
        let item = {
            ...items[index],
            name: value.name,
            monographId: value.monographId,
            brandId: value.brandId,
            monographType: Number(value.monographType),
        };
        items[index] = item;
        MedicationsFields.map((item: any, indexs: any) => {
            if (indexs == index) {
                item.name = value.name
                item.medication_name = value.name
            }
        })
        setMedications(items);
    };

    const handleindexdbdelete = async (Key: any): Promise<void> => {
        if (Indexdb != null || Indexdb != "") {
            const indexedDb = new IndexedDb(Indexdb);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('MedicationAdminstered', Key);
        }
    }

    const getMeidcationRoutes = async (): Promise<void> => {
        try {
            const medicationRoutes = localStorage.getItem("medicationRoutes");
            if (medicationRoutes) {
                setMedicationRoutes(JSON.parse(medicationRoutes));
            } else {
                const res = await api.getRoutes("");
                localStorage.setItem("medicationRoutes", JSON.stringify(res.data.model));
                setMedicationRoutes(res.data.model ?? []);
            }
        } catch { }
    };


    const getmedicationlink = async (index: any): Promise<void> => {
        let db: any = null;
        let observationdata = null;
        db = localStorage.getItem("PatientDB");
        if (db != null && db != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('MedicationAdminstered');
            for (let i = 0; i < val.length; i++) {
                if (val[i].Key === "Medication" + index) {
                    var name: any = val[i].value.name;
                    var brandId: any = val[i].value.BrandId;
                    var monographId: any = val[i].value.MonographId;
                    var monographType: any = val[i].value.MonographType;
                    setModalMedicationType({
                        brandId,
                        monographId,
                        monographType,

                    });
                    setModalMedicationName(name);
                    setIsSnowMedicationModal(true);
                }
            }
        }
    };
    const handleAddRow = async () => {
        erroradministeringchange = "";
        detailsPatientchange = "";
        detailsDrugchange = "";
        detailsTimechange = "";
        detailsDosechange = "";
        detailsRoutechange = "";
        routelength = "";
        administedbylength = "";
        administered_by = "";
        route = "";
        dose = "";
        doselength = "";
        moredetails = "";
        moredetailslength = "";
        varmedicationtime = new Date();

        setCareGiversListChanged((a: number) => a + 1);

        const lastIndex = await MedicationsFields.length;

        await MedicationsAppend({
            name: "", time: new Date(), dose: "", route: "", brand: false,
            administratedBy: "",
            errorAdministeringMedication: false,
            detailsPatient: false,
            detailsDrug: false,
            detailsTime: false,
            detailsDose: false,
            detailsRoute: false,
            moreDetails: "",
        });
        if (lastIndex >= 0) {
            const lastInput = document.getElementById(`medicationFocus${lastIndex}`) as HTMLElement;
            if (lastInput) {
                lastInput.focus();
            }
        }
        setValue(`medications[${lastIndex}].time`, new Date());
    }

    return (
        <div className={classes.medicationsFormList}>
            <div className={"headingSection"}>
                <div className={classes.pcrAddTabHeading}>
                    Medications Administered
                </div>
            </div>
            <Grid container className={classes.formContainer} spacing={0}>
                <Grid item xs={12} sm={12}>
                    {MedicationsFields.map((item, index) => (
                        <Grid container className={"FormListItem"} spacing={0} key={item.id}>
                            <Grid item xs={11} sm={11}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12}>
                                        <div className={`${classes.formControlLabel} bold`}>
                                            <Icons.RequiredIcon />MEDICATION NAME
                                        </div>
                                        <Controller
                                            control={control}
                                            name={`medications[${index}].medication_name`}
                                            defaultValue={(item.name != null || item.name != undefined) ? item.name : ""}
                                            render={({ onChange, onBlur, value, name }) => (
                                                <MedicationAutocomplete
                                                    id={`medicationFocus${index}`}
                                                    //variant='outlined'
                                                    //defaultValue={`${item.name}`} // make sure to set up defaultValue 
                                                    //value={item.name}                                                                                              
                                                    // onBlur={(e) =>
                                                    //     submit(index)
                                                    //  }                                              
                                                    //}}
                                                    SetMedname={setbrandids}
                                                    key={`medications[${index}].medication_name`}
                                                    value={`${(item.name != null || item.name != undefined) ? item.name : ""}`}
                                                    passSelection={(newValue: string, brandId: string | null, monographId: string | null, monographType: string | null) => {
                                                        onChange(newValue, handleindexsave(index, newValue, brandId, monographId, monographType));
                                                        onChangeMedicationField(index, {
                                                            name: newValue,
                                                            brandId: brandId,
                                                            monographId: monographId,
                                                            monographType: monographType,
                                                        },

                                                        );
                                                        if (brandId) {
                                                            MedicationsFields.filter((x: any) => x.name == item.name && x.id == item.id).map((item: any) => {
                                                                item.Brands = true;
                                                            })
                                                        }
                                                    }}
                                                    InputProps={{
                                                        classes: { root: classes.textFieldInput },
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <div className={item.Brands ? "ShowhelpText" : "HidehelpText"} onClick={() => { getmedicationlink(index) }}>
                                                                    <Icons.HelpIcon />
                                                                    <span>About this medication</span>
                                                                </div>

                                                            </InputAdornment>
                                                        ),

                                                    }}
                                                    isError={errors.medications?.[index]?.medication_name}
                                                    helperText={errors.medications?.[index]?.medication_name ? errors.medications?.[index]?.medication_name.message : ""}

                                                />
                                            )}
                                            rules={{
                                                required: "Medication Name field is required",
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={2}>
                                        <div className={classes.formControlLabel}>
                                            <Icons.RequiredIcon />TIME
                                        </div>
                                        <Controller
                                            control={control}
                                            name={`medications[${index}].time`}
                                            // defaultValue={new Date(`${item.time}`)}                             
                                            render={({ onChange, onBlur, value, name }) => {
                                                return (
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                                        <TimeInput
                                                            inputVariant="outlined"
                                                            //label="Material Date Picker"
                                                            id={"time" + index}
                                                            value={new Date(`${item.time}`) || null}
                                                            // defaultValue={item.time != null && item.time != undefined && item.time != '' ? new Date(`${item.time}`) :  new Date().getHours()+":"+new Date().getMinutes()+":"+new Date().getSeconds()}                          
                                                            format="HH:mm:ss"
                                                            cancelLabel={false}
                                                            okLabel={false}
                                                            autoOk={true}
                                                            onBlur={() => {
                                                                submit(index);
                                                            }}

                                                            onChange={
                                                                (date, value) => {
                                                                    onChange(date);
                                                                    handleDateChange(item.name, date, index);
                                                                }
                                                            }
                                                            error={errors.medications?.[index]?.time}
                                                            helperText={errors.medications?.[index]?.time ? errors.medications?.[index]?.time.message : ""}
                                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                                            keyboardIcon={<Icons.TimePickerIcon />}
                                                        />
                                                    </MuiPickersUtilsProvider>

                                                )
                                            }}
                                            rules={{
                                                required: "Medication Time field is required",
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={2}>
                                        <div className={classes.formControlLabel}>
                                            <Icons.RequiredIcon />DOSE
                                        </div>
                                        <Controller
                                            control={control}
                                            name={`medications[${index}].dose`}
                                            defaultValue={`${item.dose == undefined ? "" : item.dose}`}
                                            render={({ onChange, onBlur, value, name }) => (
                                                <TextField
                                                    variant='outlined'
                                                    //value={item.dose}
                                                    defaultValue={`${(item.dose != null && item.dose != undefined) ? item.dose : ""}`} // make sure to set up defaultValue 
                                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                                    inputProps={{ maxLength: 50, minLength: 0, autocomplete: 'disabled' }}
                                                    error={errors.medications?.[index]?.dose}
                                                    helperText={errors.medications?.[index]?.dose ? errors.medications?.[index]?.dose.message : ""}
                                                    onChange={(e: any) => { onChange(e, handleFormChangemedicationdose(e, index)) }}
                                                    onBlur={(e) =>
                                                        submit(index)
                                                    }
                                                />
                                            )}
                                            rules={{
                                                required: "Medication Dose field is required",
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className={classes.formControlLabel}>
                                            <Icons.RequiredIcon />ROUTE
                                        </div>
                                        <Controller
                                            control={control}
                                            name={`medications[${index}].route`}
                                            defaultValue={`${item.route == undefined ? "" : item.route}`}
                                            render={({ onChange, onBlur, value, name }) => (
                                                <>
                                                    <FormControl fullWidth error={errors.medications?.[index]?.route}>
                                                        <Select
                                                            name={name}
                                                            //value={item.route}
                                                            defaultValue={`${item.route == undefined ? "" : item.route}`} // make sure to set up defaultValue 
                                                            onChange={(e: any) => { onChange(e, handleFormChangemedicationroute(e, index)) }}
                                                            className={classes.selectField}
                                                            IconComponent={KeyboardArrowDownIcon}
                                                            displayEmpty
                                                            fullWidth={true}
                                                            variant="outlined"
                                                            onBlur={(e) =>
                                                                submit(index)
                                                            }
                                                        >
                                                            <MenuItem key="None" value={""}>--Choose--</MenuItem>
                                                            {/* <MenuItem key={1} value={"1"}>{"Oral"}</MenuItem>
                                                        <MenuItem key={1} value={"2"}>{"Oral1"}</MenuItem>
                                                        <MenuItem key={1} value={"3"}>{"Oral2"}</MenuItem> */}
                                                            {medicationRoutes.map((item) => (
                                                                <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                                                                    {item.text}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <FormHelperText>{errors.medications?.[index]?.route ? errors.medications?.[index]?.route.message : ""}</FormHelperText>
                                                    </FormControl>
                                                </>
                                            )}
                                            rules={{
                                                required: "Medication Route field is required",
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className={classes.formControlLabel}>
                                            <Icons.RequiredIcon /> ADMINISTERED BY
                                        </div>
                                        <Controller
                                            control={control}
                                            name={`medications[${index}].administratedBy`}
                                            defaultValue={`${(item.administratedBy != null || item.administratedBy != undefined) ? item.administratedBy : ""}`}
                                            render={({ onChange, onBlur, value, name }) => (
                                                <>
                                                    <FormControl fullWidth error={errors.medications?.[index]?.administratedBy}>
                                                        <Select
                                                            name={name}
                                                            defaultValue={`${(item.administratedBy != null || item.administratedBy != undefined) ? item.administratedBy : ""}`} // make sure to set up defaultValue 
                                                            onChange={(e: any) => { onChange(e, handleFormChangemedicationadministratedby(e, index)) }}
                                                            className={classes.selectField}
                                                            IconComponent={KeyboardArrowDownIcon}
                                                            displayEmpty
                                                            fullWidth={true}
                                                            variant="outlined"
                                                            onBlur={(e) =>
                                                                submit(index)
                                                            }
                                                            disabled={medicationadministered_bys.length > 0 ? false : true}
                                                        >
                                                            <MenuItem key="None" value={""}>{medicationadministered_bys.length > 0 ? "--Choose--" : "No caregivers configured"}</MenuItem>

                                                            {medicationadministered_bys.map((item) => (
                                                                <MenuItem selected={item.selected} key={item.text} defaultValue={item.text} value={item.text}>
                                                                    {item.text}
                                                                </MenuItem>
                                                            ))}

                                                        </Select>
                                                        <FormHelperText>{errors.medications?.[index]?.administratedBy ? errors.medications?.[index]?.administratedBy.message : ""}</FormHelperText>
                                                    </FormControl>
                                                </>
                                            )}
                                            rules={{
                                                required: "Medication Administered By field is required",
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Controller
                                            control={control}
                                            name={`medications[${index}].errorAdministeringMedication`}
                                            defaultValue={`${item.errorAdministeringMedication}`}
                                            render={({ onChange, onBlur, value, name }) => {
                                                return (
                                                    <>
                                                        <FormControl fullWidth error={errors.medications?.[index]?.errorAdministeringMedication}>
                                                            <FormControlLabel
                                                                name={name}
                                                                control={<Checkbox className={`${classes.checkboxInput} whiteBg`}
                                                                    checked={(item.errorAdministeringMedication != null && item.errorAdministeringMedication != "" && item.errorAdministeringMedication != undefined && item.errorAdministeringMedication != "false" && item.errorAdministeringMedication != "undefined") ? Boolean(item.errorAdministeringMedication) : false}
                                                                    // checked = {Boolean(value)}
                                                                    onChange={(e: any) => {
                                                                        onChange(e.target.checked)
                                                                        seterror_administering(e.target.checked)
                                                                        handleFormChangeerror_administering(e, index, {
                                                                            medname: item.name,
                                                                            result: e.target.checked
                                                                        })


                                                                    }} />}
                                                                label='Error administering medication'
                                                                defaultValue={`${item.errorAdministeringMedication}`}
                                                                onBlur={(e) => {
                                                                    submit(index)
                                                                }}
                                                                style={{ marginTop: 0 }}
                                                            />
                                                            <FormHelperText>{errors.medications?.[index]?.errorAdministeringMedication ? errors.medications?.[index]?.errorAdministeringMedication.message : ""}</FormHelperText>
                                                        </FormControl>

                                                        {(Boolean(item.errorAdministeringMedication)) && (<>
                                                            <div className={"errorFieldItem"}>
                                                                <FormControl fullWidth>
                                                                    <FormGroup row>
                                                                        <FormControlLabel
                                                                            control={<></>}
                                                                            label={"Wrong:"}
                                                                        />
                                                                        <Controller
                                                                            control={control}
                                                                            name={`medications[${index}].detailsPatient`}
                                                                            defaultValue={`${item.detailsPatient}`}
                                                                            render={({ onChange, onBlur, value, name }) => (

                                                                                <>
                                                                                    <FormControlLabel
                                                                                        name={name}
                                                                                        defaultValue={`${item.detailsPatient}`}
                                                                                        control={<Checkbox className={`${classes.checkboxInput} whiteBg`}
                                                                                            checked={(item.detailsPatient != null && item.detailsPatient != "" && item.detailsPatient != undefined && item.detailsPatient != "false" && item.detailsPatient != "undefined") ? Boolean(item.detailsPatient) : false}
                                                                                            // checked={Boolean(value)}
                                                                                            onChange={(e: any) => {
                                                                                                onChange(e.target.checked)
                                                                                                setwrong_detailsPatient(e.target.checked)
                                                                                                handleFormChangewrong_detailsPatient(e, index, {
                                                                                                    medname: item.name,
                                                                                                    result: e.target.checked
                                                                                                })
                                                                                            }} />}
                                                                                        label='Patient'
                                                                                        value={value}
                                                                                        onBlur={(e) => {
                                                                                            submit(index)
                                                                                        }}
                                                                                        style={{ marginTop: 0 }}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        />
                                                                        <Controller
                                                                            control={control}
                                                                            name={`medications[${index}].detailsDrug`}
                                                                            // defaultValue={`${item.detailsDrug!=null && item.detailsDrug!="" && item.detailsDrug!=undefined? item.detailsDrug : false }`}
                                                                            defaultValue={`${item.detailsDrug}`}
                                                                            render={({ onChange, onBlur, value, name }) => (
                                                                                <>
                                                                                    <FormControlLabel
                                                                                        name={name}
                                                                                        defaultValue={`${item.detailsDrug}`}
                                                                                        control={<Checkbox className={`${classes.checkboxInput} whiteBg`}
                                                                                            checked={(item.detailsDrug != null && item.detailsDrug != "" && item.detailsDrug != undefined && item.detailsDrug != "false" && item.detailsDrug != "undefined") ? Boolean(item.detailsDrug) : false}
                                                                                            onChange={(e: any) => {
                                                                                                onChange(e.target.checked)
                                                                                                setwrong_detailsDrug(e.target.checked)
                                                                                                handleFormChangewrong_detailsDrug(e, index, {
                                                                                                    medname: item.name,
                                                                                                    result: e.target.checked
                                                                                                })
                                                                                            }} />}
                                                                                        label='Drug'
                                                                                        onBlur={(e) => {
                                                                                            submit(index)
                                                                                        }}
                                                                                        style={{ marginTop: 0 }}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        />
                                                                        <Controller
                                                                            control={control}
                                                                            name={`medications[${index}].detailsTime`}
                                                                            defaultValue={`${item.detailsTime}`}
                                                                            render={({ onChange, onBlur, value, name }) => (
                                                                                <>
                                                                                    <FormControlLabel
                                                                                        name={name}
                                                                                        defaultValue={`${item.detailsTime}`}
                                                                                        control={<Checkbox className={`${classes.checkboxInput} whiteBg`}
                                                                                            checked={(item.detailsTime != null && item.detailsTime != "" && item.detailsTime != undefined && item.detailsTime != "false" && item.detailsTime != "undefined") ? Boolean(item.detailsTime) : false}
                                                                                            onChange={(e: any) => {
                                                                                                onChange(e.target.checked)
                                                                                                setwrong_detailsTime(e.target.checked)
                                                                                                handleFormChangewrong_detailsTime(e, index, {
                                                                                                    medname: item.name,
                                                                                                    result: e.target.checked
                                                                                                })
                                                                                            }} />}
                                                                                        label='Time'
                                                                                        onBlur={(e) => {
                                                                                            submit(index)
                                                                                        }}
                                                                                        style={{ marginTop: 0 }}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        />
                                                                        <Controller
                                                                            control={control}
                                                                            name={`medications[${index}].detailsDose`}
                                                                            defaultValue={`${item.detailsDose}`}
                                                                            render={({ onChange, onBlur, value, name }) => (
                                                                                <>
                                                                                    <FormControlLabel
                                                                                        name={name}
                                                                                        defaultValue={`${item.detailsDose}`}
                                                                                        control={<Checkbox className={`${classes.checkboxInput} whiteBg`}
                                                                                            checked={(item.detailsDose != null && item.detailsDose != "" && item.detailsDose != undefined && item.detailsDose != "false" && item.detailsDose != "undefined") ? Boolean(item.detailsDose) : false}
                                                                                            onChange={(e: any) => {
                                                                                                onChange(e.target.checked)
                                                                                                setwrong_detailsDose(e.target.checked)
                                                                                                handleFormChangewrong_detailsDose(e, index, {
                                                                                                    medname: item.name,
                                                                                                    result: e.target.checked
                                                                                                })
                                                                                            }} />}
                                                                                        label='Dose'
                                                                                        onBlur={(e) => {
                                                                                            submit(index)
                                                                                        }}
                                                                                        style={{ marginTop: 0 }}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        />
                                                                        <Controller
                                                                            control={control}
                                                                            name={`medications[${index}].detailsRoute`}
                                                                            defaultValue={`${item.detailsRoute}`}
                                                                            render={({ onChange, onBlur, value, name }) => (
                                                                                <>
                                                                                    <FormControlLabel
                                                                                        name={name}
                                                                                        defaultValue={`${item.detailsRoute}`}
                                                                                        control={<Checkbox className={`${classes.checkboxInput} whiteBg`}
                                                                                            checked={(item.detailsRoute != null && item.detailsRoute != "" && item.detailsRoute != undefined && item.detailsRoute != "false" && item.detailsRoute != "undefined") ? Boolean(item.detailsRoute) : false}
                                                                                            onChange={(e: any) => {
                                                                                                onChange(e.target.checked)
                                                                                                setwrong_detailsRoute(e.target.checked)
                                                                                                handleFormChangewrong_detailsRoute(e, index, {
                                                                                                    medname: item.name,
                                                                                                    result: e.target.checked
                                                                                                })
                                                                                            }} />}
                                                                                        label='Route'
                                                                                        onBlur={(e) => {
                                                                                            submit(index)
                                                                                        }}
                                                                                        style={{ marginTop: 0 }}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        />
                                                                    </FormGroup>
                                                                </FormControl>
                                                                <div style={{ marginBottom: "8px" }}></div>
                                                                <Controller
                                                                    control={control}
                                                                    name={`medications[${index}].moreDetails`}
                                                                    defaultValue={`${item.moreDetails}`}
                                                                    render={({ onChange, onBlur, value, name }) => (
                                                                        <TextField
                                                                            variant='outlined'
                                                                            defaultValue={(item.moreDetails != null || item.moreDetails != undefined) ? item.moreDetails : ""} // make sure to set up defaultValue 
                                                                            InputProps={{ classes: { root: classes.textFieldInput } }}
                                                                            inputProps={{ autocomplete: 'disabled' }}
                                                                            error={errors.medications?.[index]?.moreDetails}
                                                                            helperText={errors.medications?.[index]?.moreDetails ? errors.medications?.[index]?.moreDetails.message : ""}
                                                                            onChange={
                                                                                (e: any) =>
                                                                                    handleFormChangemedicationmoredetails(e, index, {
                                                                                        medname: item.name,
                                                                                        result: e.target.checked
                                                                                    })
                                                                            }
                                                                            onBlur={(e) => {
                                                                                setmore_detail(e.target.value)
                                                                                submit(index)
                                                                            }

                                                                            }
                                                                            placeholder={"More detail..."}
                                                                        />
                                                                    )}
                                                                    rules={{
                                                                        //required: "Other details field is required",
                                                                    }}
                                                                />
                                                            </div>
                                                        </>)}
                                                    </>
                                                )
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={1} sm={1}>
                                <div className={"removeBtn"}
                                    onClick={event => {
                                        MedicationsRemove(index)
                                        handleindexdbdelete('Medication' + index);
                                    }}>
                                    <Icons.CloseIcon />
                                </div>
                            </Grid>
                        </Grid>
                    ))}
                    <div className={"addButton"}>
                        <Button
                            className={classes.yellowBtn}
                            onClick={handleAddRow}
                        >
                            Add Medication
                        </Button>
                    </div>
                </Grid>
            </Grid>
            {isSnowMedicationModal && (
                <MedicationDetails
                    medicationInfo={modalMedicationType}
                    medicationName={modalMedicationName}
                    onClose={() => {
                        setIsSnowMedicationModal(false);
                    }}
                />
            )}
        </div>
    );
}

export default React.memo(withRouter(SubFormWidget));